import React, { createContext, useReducer, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api"; // Adjust path if needed
import { getUsers } from "../api";
// Initial State
const initialState = {
  user: null,
};

// Reducer Function
const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return { user: action.payload };
    case "LOGOUT":
      return { user: null };
    default:
      return state;
  }
};

// Create Context
export const AuthContext = createContext();

// Provider Component
export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  // Fetch users on mount
  useEffect(() => {
    getUsers().then((res) => {
        setUsers(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch users", err);
      });
  }, []);

  const login = (email, password) => {
    const user = users.find((u) => u.uname === email && u.pass === password);
    if (user) {
      dispatch({ type: "LOGIN", payload: user });
      navigate("/");
    } else {
      alert("Invalid Credentials");
    }
  };

  const logout = () => {
    dispatch({ type: "LOGOUT" });
    navigate("/login");
  };

  return (
    <AuthContext.Provider value={{ user: state.user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
